import { IShippingDestination } from '@cemex-core/cmx-api/models/destinations/shipping-destination';
import {
  OneClickPointOfDeliveriesActionTypes,
  OneClickPointOfDeliveryActions,
} from '../actions/one-click-pods.actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';

export interface OneClickPointOfDeliveryState {
  loading: boolean;
  pointOfDeliveriesAvailable: any[];
  selected: IShippingDestination;
}

export const initialState: OneClickPointOfDeliveryState = {
  loading: false,
  pointOfDeliveriesAvailable: [],
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickPointOfDeliveryActions | OneClickProfileActions,
): OneClickPointOfDeliveryState {
  switch (action.type) {
    case OneClickPointOfDeliveriesActionTypes.LOAD_PODS: {
      return {
        ...state,
        loading: true,
      } as OneClickPointOfDeliveryState;
    }
    case OneClickPointOfDeliveriesActionTypes.LOAD_PODS_COMPLETE: {
      return {
        ...state,
        loading: false,
        pointOfDeliveriesAvailable: action.payload,
      } as OneClickPointOfDeliveryState;
    }
    case OneClickPointOfDeliveriesActionTypes.SELECT_POD: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickPointOfDeliveryState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickPointOfDeliveriesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
